import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { AdministrationService } from '../administration.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  standalone: false,
})
export class NavComponent implements OnInit {
  constructor(
    public router: Router,
    private ls: LoginService,
    private administrationService: AdministrationService
  ) {
    this.ls.loginMissing();
  }

  ngOnInit(): void {}

  redirectAdministration(type) {
    this.administrationService.getUrl(type).subscribe((url) => {
      window.location.href = url;
    });
  }
}
